

import "./Contactus.scss";
import MaileSvg from "@Assets/svg/Contactus/Maile.svg";
import SupportSvg from "@Assets/svg/Contactus/support.svg";
import LocationSvg from "@Assets/svg/Contactus/Location.svg";
import DeliverySvg from "@Assets/svg/Contactus/Delivery.svg";
import GetinTouchSvg from "@Assets/svg/Contactus/getintouch.svg";
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { useFormik } from "formik";
import { ContactUsInitialValue, ContactUsSchema } from "./Schema/contactus.schema";
import { contactUs } from "./service/contactus.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useAppDispatch } from "@Src/app/hooks";
import { toast } from "react-hot-toast";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import SvgIcon from '@Components/icons/SvgIcon';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { getHomeCmsList } from "../Home/services/Home.service";

export const ContactusIndex = () => {
  const dispatch = useAppDispatch();
  const [cmsData, setCmsData] = useState<any>();
  const { handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, setFieldValue, setValues, resetForm } = useFormik({
    initialValues: ContactUsInitialValue,
    validationSchema: ContactUsSchema,
    onSubmit: (e) => {
      contactUsForm(e)

    }
  })

  const contactUsForm = (payload: any) => {
    if (isValid && touched) {
      dispatch(showSpinner(true));
      contactUs(payload).then((response: APIResponse) => {
        dispatch(showSpinner(false));
        if (response?.ResponseType === APIStatus.SUCCESS) {
          resetForm()
          toast.success('Your Query has been received. We will get back to you shortly');
        } else {
          toast.error(response.StatusMsg);
        }
      }).catch((error) => {
        dispatch(showSpinner(false));

      })
    }
  }

  const getCmsData = async () => {
    try {
      const response = await getHomeCmsList();
      if (response.ResponseType === "SUCCESS") {
        setCmsData(response?.data?.filter((item: any) => item.PageName === "contact-us"))
      }


    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    getCmsData();
  }, [])

  return (
    <>
      <section className="contact-us-section">
        <div className="ia-container">
          <div className="grid justify-content-between">
            <div className="col-12 lg:col-8 py-2">
              <div className="pt-4">
                <div className="flex align-items-center gap-2">
                  <Link to="/" className="tw-text-purple-700 hover:tw-underline">Home</Link> <span><SvgIcon name="rightArrow" size={16} style={{ padding: 0, marginTop: '6px' }} /></span>{" "}
                  <span className="active-span"> Contact Us</span>
                </div>
              </div>
              <div className="text-white pt-3 ml-0">
                <h1>Contact Us</h1>
              </div>
            </div>
            <div className="col-12 lg:col-4 pb-0">
              <img src={require("@Assets/img/cta-banner-img-3.png")} alt="" className="twt-w-full twt-h-full tw-object-cover" />
            </div>
          </div>
        </div>
        {/* <div className="flex align-items-center gap-2">
            <span>Home </span> <span><SvgIcon name="rightArrow" size={16} style={{padding:0, marginTop:'6px'}} /></span>{" "}
            <span className="active-span"> Contact Us</span>
          </div>
          <div className="m-t-l-header text-white pt-3 ml-0">
                <h1>Contact Us</h1>
            </div>
          <div className="c-u-card">
            <div className="c-u-card-left">
              Lorem ipsum dolor sit amet consectetur. Tristique proin pulvinar
              elementum bibendum viverra risus at convallis. Pharetra vel
              maecenas scelerisque imperdiet. Sed odio vitae nunc neque ut metus
              id venenatis pharetra. Sollicitudin arcu sociis enim vel. Urna
              egestas sit sagittis quam donec eget sit. Commodo semper
              ullamcorper praesent vulputate ornare eget est. Egestas fermentum
              lectus justo et erat luctus vel.
            </div>

            <div className="c-u-card-right">
              <div className="c-u-details">
                <div className="c-u-d-sub-card">
                  <span className="blue-color-span">
                    <img src={MaileSvg} alt="mailer-svg" />
                  </span>
                  <div className="tw-flex tw-flex-col">
                    <span className="c-u-tel-email">Tel: 877-67-88-99</span>
                    <span className="c-u-tel-email">
                      E-Mail: shop@store.com
                    </span>
                  </div>
                </div>
                <div className="c-u-d-sub-card">
                  <span className="blue-color-span">
                    <img src={SupportSvg} alt="mailer-svg" />
                  </span>
                  <div className="tw-flex tw-flex-col">
                    <span className="c-u-tel-email">Tel: 877-67-88-99</span>
                    <span className="c-u-tel-email">
                      E-Mail: shop@store.com
                    </span>
                  </div>
                </div>
              </div>

              <div className="c-u-details marg-div">
                <div className="c-u-d-sub-card">
                  <span className="blue-color-span">
                    <img src={LocationSvg} alt="mailer-svg" />
                  </span>
                  <div className="tw-flex tw-flex-col">
                    <span className="c-u-tel-email">Tel: 877-67-88-99</span>
                    <span className="c-u-tel-email">
                      E-Mail: shop@store.com
                    </span>
                  </div>
                </div>

                <div className="c-u-d-sub-card">
                  <span className="blue-color-span">
                    <img src={DeliverySvg} alt="mailer-svg" />
                  </span>
                  <div className="tw-flex tw-flex-col">
                    <span className="c-u-tel-email">Tel: 877-67-88-99</span>
                    <span className="c-u-tel-email">
                      E-Mail: shop@store.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
      </section>

      <section className="ia-container my-4">
        <div className="contactUs tw-bg-white tw-rounded-2xl tw-shadow-lg px-4 py-4">
          <div className="tw-grid tw-grid-cols-2 gap-3 md:gap-6">
            <div className="tw-col-span-2 md:tw-col-span-1">
              <h2>Get in Touch</h2>
              <p>Have questions? Need more details on how to get started? Reach out now for expert assistance.</p>
            </div>
          </div>

          <div className="tw-grid tw-grid-cols-2 gap-3 md:gap-6">
            <div className="tw-col-span-2 md:tw-col-span-1">
              <form onSubmit={handleSubmit}>
                <div className="tw-grid tw-grid-cols-2 gap-4 mt-4">
                  <div className="tw-col-span-2 md:tw-col-span-1">
                    <InputText
                      value={values.Name}
                      id="Name"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      type="text"
                      placeholder="Name*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <br />
                    {touched.Name && errors.Name ? (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {errors.Name}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-1">
                    <InputText
                      value={values.EmailId}
                      id="EmailId"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Email id*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <br />
                    {touched.EmailId && errors.EmailId ? (
                      <p className="tw-text-red-500 tw-text-sm">
                        {errors.EmailId}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-1">
                    <InputText
                      keyfilter="num"
                      value={values.ContactNumber}
                      id="ContactNumber"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Contact Number*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={10}
                      minLength={10}
                      onKeyDown={(e) => {


                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {touched.ContactNumber && errors.ContactNumber ? (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {errors.ContactNumber}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2 md:tw-col-span-1">
                    <InputText
                      value={values.Subject}
                      id="Subject"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      placeholder="Subject*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.Subject && errors.Subject ? (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {errors.Subject}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2">
                    <InputTextarea
                      value={values.Description}
                      id="Description"
                      className="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-3 px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline"
                      rows={5}
                      cols={30}
                      placeholder="Type Your Message*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ resize: "none" }}
                    />
                    {touched.Description && errors.Description ? (
                      <p className="tw-text-red-500 tw-text-sm ">
                        {errors.Description}
                      </p>
                    ) : null}
                  </div>
                  <div className="tw-col-span-2">
                    <button type="submit" className="ia-btn ia-btn-primary px-6">
                      Send Mail
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="tw-col-span-2 md:tw-col-span-1">
              <div className="tw-grid tw-grid-cols-2 gap-4 mt-4">
                {
                  cmsData && <>
                    <div className="tw-col-span-2 md:tw-col-span-1">
                      <div className="flex align-items-center gap-2">
                        <span className="blue-color-span">
                          <img src={SupportSvg} alt="mailer-svg" />
                        </span>
                        <div className="tw-flex tw-flex-col">
                          <span className="tw-text-lg tw-font-semibold">Phone:</span>
                          {/* <span className="c-u-tel-email">877-67-88-99</span> */}
                          <span className="c-u-tel-email" dangerouslySetInnerHTML={{ __html: cmsData.filter((item: any) => item.KeyName === 'phone')[0]?.Description }}></span>
                        </div>
                      </div>
                    </div>
                    <div className="tw-col-span-2 md:tw-col-span-1">
                      <div className="flex align-items-center gap-2">
                        <span className="blue-color-span">
                          <img src={MaileSvg} alt="mailer-svg" />
                        </span>
                        <div className="tw-flex tw-flex-col">
                          <span className="tw-text-lg tw-font-semibold">Email:</span>
                          {/* <span className="c-u-tel-email">
                        shop@store.com
                      </span> */}
                          <span className="c-u-tel-email"  dangerouslySetInnerHTML={{ __html: cmsData.filter((item: any) => item.KeyName === 'email')[0]?.Description}}></span>
                        </div>
                      </div>
                    </div>
                    <div className="tw-col-span-2 md:tw-col-span-1">
                      <div className="flex align-items-center gap-2">
                        <span className="blue-color-span">
                          <img src={LocationSvg} alt="mailer-svg" />
                        </span>
                        <div className="tw-flex tw-flex-col">
                          <span className="tw-text-lg tw-font-semibold">Location:</span>
                          {/* <span className="c-u-tel-email">Address</span> */}
                          <span className="c-u-tel-email"  dangerouslySetInnerHTML={{ __html: cmsData.filter((item: any) => item.KeyName === 'location')[0]?.Description }}></span>
                        </div>
                      </div>
                    </div>
                  </>
                }

                <div className="tw-col-span-2 md:tw-col-span-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );

}